<template>
  <div>
    <div
        v-if="parallax && parallax.properties.src"
        :style="parallaxStyle"
    >
      <slot></slot>
    </div>
    <div v-else-if="defaultStyle" :style="defaultStyle">
      <slot></slot>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'CustomParallax',

  mixins: [globalMixins],

  props: {
    parallax: {
      type: Object
    },
    defaultStyle: {
      type: Object
    }
  },

  data() {
    return {
      parallaxStyle: {
        'background': 'center center / cover no-repeat fixed rgba(0,0,0,0.3)',
        'min-height': (this.parallax && this.parallax.properties && this.parallax.properties.height) ? this.parallax.properties.height + 'px' : '500px'
      }
    }
  },

  async created() {

    if (this.parallax && this.parallax.properties && this.parallax.properties.style)
      this.parallaxStyle = this._.cloneDeep(this.parallax.properties.style);

    this.parallaxStyle['background'] = 'center center / cover no-repeat fixed rgba(0,0,0,0.3)';

    if (this.parallax && this.parallax.properties) {
      this.parallaxStyle['background-image'] = `url(${this.parallax.properties.srcCrop || this.parallax.properties.src})`;
      this.parallaxStyle['min-height'] = this.parallax.properties.height || '500px';
    }
    this.$forceUpdate();
  }
}
</script>
<style>
.parallax {
  background: center center / cover no-repeat fixed rgba(0, 0, 0, 0.3);
}
</style>